export const ROUTES = {
  DASHBOARD: "/",
  _PATIENT_BY_ID: "/p/:patientId",
  _CONVERSATION: "/c/:shortcode",
  _SHARED_BY_ID: "/shared-with/:conversationId",
  SHARED_BY_ID: "/shared-with",
  PATIENT_BY_ID: "/p",
  CONVERSATION: "/c",
  // Legacy aliases for backward compatibility
  _PATIENT: "/c/:shortcode",
  PATIENT: "/c",
};

// Admin panel routes (external - admin-frontend)
const ADMIN_BASE = process.env.REACT_APP_ADMIN_FRONTEND_URL || 'http://localhost:3001';
export const ADMIN_ROUTES = {
  USERS: `${ADMIN_BASE}/users`,
  GUIDELINES: `${ADMIN_BASE}/guidelines`,
  PIPELINE: `${ADMIN_BASE}/pipeline`,
};
